export const SET_PIN_DEEPLINK_QUERY_PARAMS = {
  APP_ID: 'app_id',
};

export const SET_PIN_DEEPLINK_SESSION_KEYS = {
  RETURN_URL: 'set_pin_deeplink.returnUrl',
};
